import * as T from '@/types'
import { AxiosInstance, AxiosRequestConfig, AxiosPromise } from 'axios'
import { AuthResource } from '@/api/resources/auth'
import { CasesResource } from '@/api/resources/cases'
import { CreditorsResource } from '@/api/resources/creditors'
import { FilesResource } from '@/api/resources/files'
import { TagsResource } from '@/api/resources/tags'
import { SourcesResource } from '@/api/resources/sources'

////////////////////////////////////////////////////////////////
// filters
////////////////////////////////////////////////////////////////

export type Filter = T.RangeFilter<any> | T.EntityFilter<any> | T.SearchFilter | T.BooleanFilter | T.ArrayFilter

export interface Filters {
    [key: string]: T.Filter
}

export enum FilterType {
    RANGE = 'FilterType.RANGE',
    ENTITY = 'FilterType.ENTITY',
    CONTAINS = 'FilterType.CONTAINS',
    SEARCH = 'FilterType.SEARCH',
    BOOLEAN = 'FilterType.BOOLEAN',
}

export interface RangeFilter<T> {
    from?: T
    to?: T
}

export type EntityFilter<T> = (T | null) | (T | null)[]

export type ContainsFilter<T> = (T | null)

export type SearchFilter = string

export type BooleanFilter = boolean

export type ArrayFilter = string[]

export interface Sorts {
    [key: string]: boolean
}

////////////////////////////////////////////////////////////////
// API client
////////////////////////////////////////////////////////////////

export interface CreditorDeskApi extends AxiosInstance {
    auth: AuthResource
    cases: CasesResource
    creditors: CreditorsResource
    files: FilesResource
    tags: TagsResource
    sources: SourcesResource
}

// Won't need this unless using makeRequest
// Should make individual typings for API functions
export interface CreditorDeskApiRequestParams {
    requestType: T.ApiRequestType
    routeParams?: T.Dictionary<T.EntityId>
    data?: T.Dictionary<any>
    queryParams?: T.Dictionary<any>
    config?: AxiosRequestConfig
    transactionUid?: T.Uid
}
